module.exports = __webpack_public_path__ + "img/icon-jiso-footer.71c0288d.png";